export default __webpack_public_path__ + "static/media/alert-triangle.c361f0b4.svg";